import React, { createContext, useContext, useState } from "react";
import LayoutManager from "../shared/LayoutManager";

type PanelType = "login" | "signup" | "forgot" | null;

type AuthModalContextType = {
  openLogin: () => void;
  openSignup: () => void;
  openForgot: () => void;
  closeModal: () => void;
};

const FlyoutContext = createContext<AuthModalContextType | undefined>(undefined);

export const FlyoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activePanel, setActivePanel] = useState<PanelType>(null);

  const openLogin = () => {
    setActivePanel((prev) => (prev === "login" ? null : "login"));
  };
  const openSignup = () => setActivePanel("signup");
  const openForgot = () => setActivePanel("forgot");
  const closeModal = () => setActivePanel(null);

  return (
    <FlyoutContext.Provider value={{ openLogin, openSignup, openForgot, closeModal }}>
      {children}
      {activePanel && (
        <LayoutManager
          key={activePanel}
          activePanel={activePanel}
          onClose={closeModal}
          onSwitch={(panel) => setActivePanel(panel)}
        />
      )}
    </FlyoutContext.Provider>
  );
};

export const useFlyout = () => {
  const context = useContext(FlyoutContext);
  if (!context) throw new Error("useFlyout must be used inside FlyoutProvider");
  return context;
};
